export default __webpack_public_path__ + "static/media/5627fd1cb55d53949fb254a57c3d8d291602175527981.1fbefda2.webp";